import Script from 'next/script';

import Preferences from './_components/preferences/Preferences';
import ConsentBanner from './_components/consent/ConsentBanner';
import useAnalytics from './hooks/useAnalytics';

export default function Analytics(): JSX.Element | null {
  const {
    hydrated,
    open,
    scriptSrc,
    togglePreferences,
    closePreferences,
    acceptCookies,
    rejectCookies,
  } = useAnalytics();

  if (!hydrated) return null;

  return (
    <>
      {scriptSrc && (
        <Script id="delps-ga4" strategy="afterInteractive" src={scriptSrc} />
      )}
      <Preferences open={open} onToggle={togglePreferences} />
      {open && (
        <ConsentBanner
          onClose={closePreferences}
          onAccept={acceptCookies}
          onReject={rejectCookies}
        />
      )}
    </>
  );
}
